import {createSheetService} from './sheetServiceFactory';

const service = createSheetService('Cases', [
  'id',
  'platform',
  'category',
  'description',
  'link',
  'status',
  'reports',
  'anonymous',
  'screenshot_name',
  'review_note',
  'date',
  'created_at',
  'updated_at',
  'views'
]);

export const listCases = service.list;
export const getCase = service.getById;
export const createCase = service.create;
export const updateCase = service.update;
export const deleteCase = service.remove;